import React from "react";
import  sAction  from "sAction";
import TimelineOrig from "ROOT/src/components/Timeline/Timeline";

export default class Timeline extends TimelineOrig {
  getTimelinePoint(data,state) {
    var clickable = false;
    const value = this.props.value;
    
    let title = data.title;
    if (sAction.getStorage("debug")) {
      title = !title ? data.value : data.value + " | " + title;
    }
    return (
      <div key={data.value} className="acmTimelinePointContainer">
        <div className="acmTimelinePoint">
          <div 
          className={clickable == true && data.clickAble == true ? "acmTimelinePointCenter clickable " + state : "acmTimelinePointCenter " + state}
          title={title}
          >
          {data.label}
          </div>
        </div>

      </div>
    );
  }

  render() {
    const data = this.props.data;
    const value = this.props.value;

    var renderData = [];
    var pointState = "colored";
    let i = 0;
    data.forEach(point => {
      i++;
      if (value.value == point.value) {
        pointState = "now";
        if (point.label) {
          point.label = <React.Fragment><span className="acmTimelinePointNumber"></span>{point.label}</React.Fragment>;
        }
      } else if (point.label) {
        point.label = point.label;
      }

      renderData.push(this.getTimelinePoint(point,pointState));
      if (value.value == point.value) {
        pointState = "alreadySet";
      }
    });

    return <div className="acmTimeline">{renderData}</div>;
  }
}
